/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Box, IconButton, Tooltip } from "@mui/material";
import { MRT_Row } from "material-react-table";
import { EArgosReportsState, tableButtonGray } from "../../../../../../constants/colors";
import { setGlobalRightClickMenuData, setGlobalRightClickMenuPosition } from "../../../../../../redux/ducks/GlobalRightClickMenu/slice";
import ADAS_PROGRAMS_CONSTANTS from "../../../constants";
import {AdasProgramsReportPages, pageToHtabIndexMap, ReportsTableData} from "../constants";
import { ArgosEditIcon, ArgosViewDetailsIcon } from "../../../../../components/Icons/ArgosActionIcons";
import { AppDispatch } from '../../../../../../redux/store';
import { ReportsTableRowActionTypes } from './types';
import { ArgosCopy, ArgosCopyTwoTone } from "../../../../../components/Icons/ArgosDatasetControlPanelIcons";
import { useState } from "react";
import toast from "react-hot-toast";


interface RowActionsProps {
  adasProgramId: string
  page: AdasProgramsReportPages
  dispatch: AppDispatch
  onClickAction: (action: ReportsTableRowActionTypes, _reportId: string) => void
  isReadOnlyProgram: boolean

}
/**
 * @description Function to handle the copy action
 * @returns {void}
 * 1. Copy the URL to the clipboard
 * 2. Set the copied state to true
 */
export const handleCopy = async (url: string, copied: boolean, setCopied: any) => {
  try {
    await navigator.clipboard.writeText(window.location.origin + url);
    setCopied(true);
  } catch (error) {
    toast.error("Failed to copy text to clipboard");
    console.error("Failed to copy text to clipboard:", error);
  }
}
export const RowActions = (row: MRT_Row<ReportsTableData>, props: RowActionsProps) => {
  const { adasProgramId, dispatch, page, onClickAction, isReadOnlyProgram } = props
  const originalRow = row?.original
  const reportId = originalRow?.reportId
  const [copied, setCopied] = useState(false);
  const htabName = ADAS_PROGRAMS_CONSTANTS.itemDetails.horizontalTabs.pageHtabs.tabIndexUrlKey
  const htabIdx = pageToHtabIndexMap[page]
  const url = `${ADAS_PROGRAMS_CONSTANTS.itemDetails.coverageRequirements.viewReportRoute}?adasProgramId=${adasProgramId}&reportId=${reportId}&${htabName}=${htabIdx}`
  const datasetState: string = row.original.dataSetState
  const disableViewIcon = datasetState === EArgosReportsState.MODIFIED || datasetState === EArgosReportsState.DELETED


  return (
    <Box
      sx={{
        display: row.subRows?.length ? 'none' : 'flex',
        flexWrap: 'nowrap'
      }}
    >
      {!disableViewIcon && <><Tooltip title="View">
        <a
          onClick={(e) => {
            e.stopPropagation()
            onClickAction(ReportsTableRowActionTypes.VIEW_REPORT, reportId)
          }}
          onContextMenu={(e) => {
            e.preventDefault()
            dispatch(setGlobalRightClickMenuData({url}))
            dispatch(setGlobalRightClickMenuPosition({x: e.pageX, y: e.pageY}))
          }}
        >
          <IconButton size="large">
            <ArgosViewDetailsIcon fontSize="medium" style={{color: tableButtonGray}} />
          </IconButton>
        </a>
      </Tooltip>
      <Tooltip title={copied ? "Copied" : "Copy"}>
        <IconButton size="large" onClick={() => handleCopy(url, copied, setCopied)} onMouseLeave={() => setTimeout(() => setCopied(false), 2000)}>
            {copied ? <ArgosCopyTwoTone fontSize="medium" style={{color: tableButtonGray}} /> : <ArgosCopy fontSize="medium" style={{color: tableButtonGray}} />}
        </IconButton>
      </Tooltip></>}
      {!isReadOnlyProgram && <Tooltip title="Edit">
        <IconButton size="large" onClick={() => onClickAction(ReportsTableRowActionTypes.EDIT_REPORT, reportId)}>
          <ArgosEditIcon fontSize="medium" style={{color: tableButtonGray}} />
        </IconButton>
      </Tooltip>}
    </Box>
  )
}
